var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"dropdown",attrs:{"value":_vm.value,"options":_vm.options,"searchable":false,"clearable":false,"components":{ OpenIndicator: _vm.OpenIndicator }},on:{"input":value => _vm.$emit('input', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }